import React, { useCallback, useState } from 'react';
import { Box, Button } from 'edenred-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useForm } from 'react-hook-form';

import { getLoginOtpVerifyAction } from '@epi-actions/login';
import { ApiConstants } from '@epi-constants/actions';
import { ErrorPanel } from '@epi-components/ErrorPanel/ErrorPanel';
import { isFetching } from '@epi-selectors/login';
import { OtpVerificationField } from '../OtpVerificationField/OtpVerificationField';

export function OtpVerificationForm() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();
  const isProcessing = useSelector(isFetching);

  const [otpCode, setOtpCode] = useState('');
  const [isCodeComplete, setIsCodeComplete] = useState(false);
  const isSubmitBtnDisabled = !isCodeComplete || isProcessing;

  const onSubmit = () => {
    if (isSubmitBtnDisabled) {
      return;
    }

    dispatch(getLoginOtpVerifyAction(otpCode));
  };

  const handleOtpVerificationChanged = useCallback((code, isComplete) => {
    setOtpCode(code);
    setIsCodeComplete(isComplete);
  }, []);

  const form = useForm();

  return (
    <form noValidate onSubmit={form.handleSubmit(onSubmit)}>
      <Box
        fontSize={theme.sizeExtraExtraLarge}
        fontWeight={theme.fontSemiBold}
        textAlign="center"
        px={5}
        pb={1}
      >
        {t('login_otp.heading')}
      </Box>
      <Box fontSize={theme.sizeMedium} textAlign="center">
        {t('login_otp.subheading')}
      </Box>
      <Box my={3}>
        <ErrorPanel failedActionName={ApiConstants.LOGIN_OTP_VERIFY_ACTION} />
      </Box>
      <OtpVerificationField
        onCompletionChanged={handleOtpVerificationChanged}
      />
      <Box mt={4}>
        <Button fullWidth id="otp-confirm-btn" disabled={isSubmitBtnDisabled}>
          {t('login_otp.confirm_btn')}
        </Button>
      </Box>
    </form>
  );
}
